import React, { useState, useEffect } from 'react';
import {
    ArrowLeft,
    Bookmark,
    Share,
    Clock,
    Eye,
    ThumbsUp,
    ChevronUp,
    ChevronDown
} from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './../../firebase';
const BlogDetailsPage = () => {
    const { id } = useParams();
    const [blogData, setBlogData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchBlogData = async () => {
            if (!id) {
                setError('No blog ID provided');
                setLoading(false);
                return;
            }

            try {
                const docRef = doc(db, 'blogs', id);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    setBlogData(docSnap.data());
                } else {
                    setError('Blog not found');
                }
            } catch (err) {
                console.error('Error:', err);
                setError('Failed to load blog');
            } finally {
                setLoading(false);
            }
        };

        fetchBlogData();
    }, [id]);

    if (loading) return <p style={{ textAlign: 'center', marginTop: '40px' }}>Loading blog...</p>;
    if (error) return <p style={{ textAlign: 'center', color: 'red', marginTop: '40px' }}>{error}</p>;
    if (!blogData) return null;

    const {
        title,
        content,
        author,
        category,
        tags,
        featuredImage,
        featuredType,
        additionalImages
    } = blogData;

    return (
        <div style={styles.container}>
            {/* Back Button */}
            <div>
                <button
                    onClick={() => navigate('/blogs')}
                    style={{
                        background: 'linear-gradient(to right, #1976d2, #512da8)',
                        color: 'white',
                        padding: '10px 20px',
                        margin: "20px",
                        fontSize: '20px',
                        // padding:"20px",
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        position: 'inherit',
                        top: '20px',
                        left: '20px',
                        zIndex: 1000,
                    }}
                >
                    Back
                </button>
            </div>

            {featuredType === 'video' ? <video src={featuredImage} alt={title} controls style={styles.featuredImage} /> :
                <img src={featuredImage} alt={title} style={styles.featuredImage} />

            }

            <div style={styles.contentWrapper}>
                <h1 style={styles.title}>{title}</h1>
                <p style={styles.category}>Category: <strong>{category}</strong></p>

                <div style={styles.authorSection}>
                    <img src={author.avatar || 'https://via.placeholder.com/60'} alt={author.name} style={styles.avatar} />
                    <div>
                        <p style={styles.authorName}>{author.name}</p>
                        <p style={styles.authorBio}>{author.bio}</p>
                    </div>
                </div>

                <div style={styles.tagsContainer}>
                    {tags.map((tag, idx) => (
                        <span key={idx} style={styles.tag}>#{tag}</span>
                    ))}
                </div>

                <p style={styles.content}>{content}</p>

                {additionalImages.length > 0 && (
                    <div style={styles.additionalImagesWrapper}>
                        <h3 style={styles.subHeading}>More Images</h3>
                        <div style={styles.additionalImages}>
                            {additionalImages.map((url, idx) => (
                                <img key={idx} src={url} alt={`extra-${idx}`} style={styles.additionalImage} />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const styles = {
    container: {
        fontFamily: "'Segoe UI', sans-serif",
        maxWidth: '900px',
        margin: '40px auto',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        overflow: 'hidden',
        backgroundColor: '#fff'
    },
    featuredImage: {
        width: '100%',
        height: '400px',
        px:"10px",
        objectFit: 'cover'
    },
    contentWrapper: {
        padding: '30px'
    },
    title: {
        fontSize: '36px',
        marginBottom: '10px',
        color: '#333'
    },
    category: {
        fontSize: '14px',
        color: '#777',
        marginBottom: '20px'
    },
    authorSection: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '25px'
    },
    avatar: {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        marginRight: '15px'
    },
    authorName: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#222'
    },
    authorBio: {
        fontSize: '14px',
        color: '#666'
    },
    tagsContainer: {
        marginBottom: '20px'
    },
    tag: {
        display: 'inline-block',
        backgroundColor: '#e3f2fd',
        color: '#1976d2',
        padding: '6px 12px',
        marginRight: '10px',
        borderRadius: '16px',
        fontSize: '12px',
        fontWeight: '500'
    },
    content: {
        fontSize: '17px',
        color: '#333',
        lineHeight: '1.8',
        whiteSpace: 'pre-line',
        marginBottom: '40px'
    },
    additionalImagesWrapper: {
        marginTop: '40px'
    },
    subHeading: {
        fontSize: '20px',
        marginBottom: '16px',
        color: '#444'
    },
    additionalImages: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px'
    },
    additionalImage: {
        width: 'calc(33.33% - 10px)',
        height: '180px',
        objectFit: 'cover',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    }
};

export default BlogDetailsPage;